import React from 'react'
import { Container } from 'reactstrap'
import { Link } from 'react-router-dom'

import { Alert } from '../../../components/reactstrap'
import PropTypes from 'prop-types'
import { Trans, useTranslation } from 'react-i18next'

const UnusedStringsBanner = ({ count, projectId }) => {
  const { t } = useTranslation('ProjectsPage')

  return (
    <Container fluid>
      <Alert className="d-flex flex-row flex-fill justify-content-between align-items-center" color="warning">
        <div className="d-block">
          <Trans i18nKey="ProjectsPage:ProjectUnusedStrings.alert.message" count={count}>
            This project has
            {{ count }}
            strings which are no more existing in the project&apos;s
            reference languages files.
          </Trans>
        </div>
        <Link
          className="btn btn-warning text-white text-decoration-none px-5"
          to={`/projects/${projectId}/unused-strings`}
        >
          {t('ProjectUnusedStrings.alert.button')}
        </Link>
      </Alert>
    </Container>
  )
}

UnusedStringsBanner.propTypes = {
  count: PropTypes.number.isRequired,
  projectId: PropTypes.string.isRequired
}

export default UnusedStringsBanner
